import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ExpandingView from './ExpandingView.jsx';
import TriangledView from './TriangledView.jsx';

const DEMO_TITLE = 'nordstrom';
const DEMO_CATEGORIES = 'Fashion retailer';
const DEMO_DESCRIPTION = 'Ad duis commodo exercitation do laborum et consectetur velit do tempor elit voluptate adipisicing culpa. Fugiat exercitation dolor et eiusmod reprehenderit dolore. Qui est sunt cupidatat labore in et proident consequat. Cillum Lorem elit cupidatat proident ullamco. Dolor eiusmod pariatur nisi occaecat sit velit dolore eu ad sunt exercitation irure quis.Non voluptate ex duis esse aliquip sunt laborum cillum sunt laboris. Lorem in dolor voluptate fugiat elit. Culpa culpa esse nisi amet voluptate ipsum cupidatat. Magna nostrud voluptate reprehenderit anim sint cupidatat in pariatur. Elit sunt aliquip proident labore excepteur duis ex adipisicing aute deserunt eu. Pariatur cupidatat ex mollit id quis ad pariatur ullamco. Quis commodo reprehenderit minim Lorem sit amet mollit.';
const DEMO_IMAGES = [{},{},{}];

const propTypes = {
  size: PropTypes.number,
  currentPinPoi: PropTypes.object,
  demo: PropTypes.bool,
  poiDetailsViewOpen: PropTypes.bool,
  className: PropTypes.any,
};
const defaultProps = {
  size: 16,
  currentPoi: {},
  currentPinPoi: null,
  poiDetailsViewOpen: false,
};

const Container = styled.div`
  position: relative;
`;

export const getMarkerPosition = async (markerPOI, markerEl) => {

    const markerSize = markerEl ? markerEl.getBoundingClientRect().height : 511;

    // should be using Refs to get the targetPOI :O
    const getPosition = new Promise(resolve => {
        setTimeout(() => {
            const markerPOIel = document.getElementById(markerPOI);
            const poiPosition = markerPOIel ? markerPOIel.getBoundingClientRect() : null;
            resolve(poiPosition);
        }, 600);
    });

    const poiPosition = await getPosition;

    if ( markerSize && poiPosition) {
        const position = poiPosition && {
                position: 'absolute',
                display: 'inline-block',
                opacity: '1',
                left: `${poiPosition.left}px`,
                top: `${poiPosition.top - markerSize}px`
            };

        return position;
    } else {
        return {};
    }
}

export default class PoiDetailsView extends React.Component {
  inputRef = React.createRef()

  constructor(props) {
    super(props)
    this.state = {
      isExpandingViewOpen: false,
      markerStyle: {position: 'absolute', display: 'inline-block', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', opacity: '0'}
    }
    window.updateMarkerPosition = this.updateMarkerPosition;
  }

  onInfoButtonClick = () => this.setState({isExpandingViewOpen: !this.state.isExpandingViewOpen})

  onDirectionsButtonClick = () => console.log('Directory Button Clicked')

  onShareButtonClick = () => console.log('Share Button Clicked')

  updateMarkerPosition = async () => {
    const markerPOI = this.props.markerPOI;
    const markerEl = ReactDOM.findDOMNode(this);
    // const markerEl = this.inputRef;
    const markerStyle = await getMarkerPosition(markerPOI, markerEl);
    this.setState({ markerStyle });
  }

  componentDidMount() {
    this.updateMarkerPosition();
  }

  componentWillReceiveProps(nextProps) {
    this.updateMarkerPosition();
  }

  render () {
    // if (!poiData) return null;

    const {
      size,
      poiData,
      demo,
      poiDetailsViewOpen,
    } = this.props;

    const {
      isExpandingViewOpen,
      markerStyle
    } = this.state;

    const {
      name,
      description,
      media = [],
      categories = [],
    } = poiData;

    let modeAdjTitle;
    let modeAdjCategories;
    let modeAdjDescription;
    let modeAdjImages;

    if (demo) {
      modeAdjTitle = DEMO_TITLE;
      modeAdjCategories = DEMO_CATEGORIES;
      modeAdjDescription = DEMO_DESCRIPTION;
      modeAdjImages = DEMO_IMAGES;
    } else {
      modeAdjTitle = name;
      modeAdjCategories = categories.length
        ? categories.map(cat => cat.name).join(', ')
        : null;
      modeAdjDescription = description;
      modeAdjImages = media;
    }

    return <Container size={size}
                      ref={this.inputRef}
                      className={this.props.className}
                      style={markerStyle}>
      <ExpandingView
        size={size}
        isOpen={isExpandingViewOpen}
        text={modeAdjDescription}
        images={modeAdjImages}
      />
      <TriangledView
        title={modeAdjTitle}
        categories={modeAdjCategories}
        size={size}
        onInfoButtonClick={this.onInfoButtonClick}
        onDirectionsButtonClick={this.onDirectionsButtonClick}
        onShareButtonClick={this.onShareButtonClick}
      />
    </Container>
  }
}

// PoiDetailsView.propTypes = propTypes;
// PoiDetailsView.defaultProps = defaultProps;
//
// const mapStateToProps = state => {
//   return {
//     currentPinPoi: state.kioskUI.currentPinPoi,
//     poiDetailsViewOpen: state.kioskUI.poiDetailsViewOpen,
//   }
// }
//
// export default connect(mapStateToProps, null)(PoiDetailsView);



// WEBPACK FOOTER //
// ./src/components/PoiDetailsView/PoiDetailsView.jsx